import { useRef } from "react";

import { useStore } from "../../stores/StoreContext";
import { DisclaimerService } from "../LogicServices/DisclaimerService";

export function useDisclaimerService(): DisclaimerService {
  const storeContext = useStore();
  const serviceRef = useRef<DisclaimerService | null>(null);

  if (!serviceRef.current) {
    serviceRef.current = new DisclaimerService(storeContext);
  }

  return serviceRef.current;
}
